import { render } from "./LocationPinSvg.vue?vue&type=template&id=2522970e"
import script from "./LocationPinSvg.vue?vue&type=script&lang=js"
export * from "./LocationPinSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__